/*
 * Created Date: 29-01-2024, 2:59:18 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Wed Feb 28 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import MyAccountNavigationConfig from './MyAccountNavigationConfig'
import MyAccountRouterConfig from './MyAccountRouterConfig'

const MyAccountConfig = {
	navigation: [MyAccountNavigationConfig],
	router: MyAccountRouterConfig
}

export default MyAccountConfig
